/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

import React from "react";
import Button from "components/generals/Button";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

interface SwaggerButtonProps {
  variant?: "text" | "outlined" | "contained";
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
}

const SwaggerButton: React.FC<SwaggerButtonProps> = ({ 
  variant = "contained", 
  color = "info",
  size = "medium",
  fullWidth = false
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const handleOpenSwagger = () => {
    // Obtener el token JWT del localStorage (guardado como 'accessToken')
    const token = localStorage.getItem('accessToken');
    
    if (!token) {
      enqueueSnackbar('No se encontró token de autenticación. Por favor, inicia sesión nuevamente.', {
        variant: 'error'
      });
      return;
    }

    // URL del backend con el token como query parameter
    const backendUrl = process.env.REACT_APP_API_BASE_URL + `/api?token=${encodeURIComponent(token)}`;
    
    // Abrir Swagger en una nueva pestaña
    const newWindow = window.open(backendUrl, '_blank');
      
    if (!newWindow) {
      enqueueSnackbar('No se pudo abrir la ventana. Verifica que los pop-ups estén habilitados.', {
        variant: 'warning'
      });
    } else {
      enqueueSnackbar('Abriendo documentación de Swagger...', {
        variant: 'success'
      });
    }
  };

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      onClick={handleOpenSwagger}
    >
      {t("swaggerButton.swaggerDoc")}    
    </Button>
  );
};

export default SwaggerButton;
